class InspirationGallery {
    private galleryElement: HTMLElement;
    private items: HTMLElement[];
    private thumbnails: HTMLElement[];

    constructor(element: HTMLElement) {
        this.galleryElement = element;
        this.galleryElement.classList.add("inspirationGallery--setup");
        
        this.items = Array.from(this.galleryElement.querySelectorAll('.inspirationGallery__viewerItem'));
        this.thumbnails = Array.from(this.galleryElement.querySelectorAll('.inspirationGallery__thumbnail'));
        
        this.setupThumbnailListeners();
    }

    private setupThumbnailListeners(): void {
        this.thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => this.activateItem(index));
        });
    }

    private activateItem(index: number): void {
        // Deactivate all items and pause videos
        this.items.forEach(item => {
            if (item.classList.contains('inspirationGallery__viewerItem--active')) {
                const video = item.querySelector('video');
                if (video instanceof HTMLVideoElement) {
                    video.pause();
                }
            }
            item.classList.remove('inspirationGallery__viewerItem--active');
        });

        // Deactivate all thumbnails
        this.thumbnails.forEach(thumbnail => thumbnail.classList.remove('inspirationGallery__thumbnail--active'));

        // Activate the selected item and thumbnail
        if (this.items[index]) {
            this.items[index].classList.add('inspirationGallery__viewerItem--active');
        }
        if (this.thumbnails[index]) {
            this.thumbnails[index].classList.add('inspirationGallery__thumbnail--active');
        }
    }
}

function initializeInspirationGalleries(): void {
    document.querySelectorAll('.inspirationGallery:not(.inspirationGallery--setup)').forEach((element) => {
        if (element instanceof HTMLElement) {
            new InspirationGallery(element);
        }
    });
}

function init(): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeInspirationGalleries);
    } else {
        initializeInspirationGalleries();
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                initializeInspirationGalleries();
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

init();